import * as React from "react";
import * as _ from "lodash";
import { IPatientAllergy } from "@curefit/ehr-common";
import IVital from "../../models/staticData/IVital";
import {IPatientVitalResponse} from "../../models/IPatientVitalResponse";
import IPatientVital from "../../models/IPatientVital";
import TodaysVitalsEditViewCont from "../../containers/EditView/TodaysVitalsEditViewCont";
import AllergyEditViewCont from "../../containers/EditView/AllergyEditViewCont";
import {EditViewDisplayMode} from "../common/EditViewCard";
import {default as VitalsChartContainer} from "../../containers/VitalsChartContainer";
import IEditedBy from "../../models/IEditedBy";
import CollapsibleCardView from "../CollapsibleCardView";
import ErrorContainer from "./../../containers/ErrorContainer"
import {AppMessages} from "../../utils/AppConstants";
import {ITypeFormResponse} from "../../models/ITypeFormResponse";

/**
 * Created by aditya on 23/02/18.
 */

export interface PatientVitalsAndAllergiesTabProps {
    appointmentId?: number,
    editedBy: IEditedBy,
    userId: number,
    patientId: number,
    metricIds: number[],
    patientVitals: IPatientVitalResponse[],
    staticVitalList: IVital[],
    fetchPatientVitals: (patientId: number) => any,
    savePatientVitals: (patientId: number, patientVitals: IPatientVital[]) => any,
    fetchAllStaticData: () => any,
    patientAllergies: IPatientAllergy[],
    saveEditedVitalsAndAllergies: (allergies: IPatientAllergy[]) => void;
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: any, appointmentId: number, doctorType: string) => any,
    currentAllergies: IPatientAllergy[],
    nextTab: () => void,
    patientTypeFormData?: ITypeFormResponse;
    typeFormMapping?: any;
    doctorType: string,
}

export interface PatientVitalsAndAllergiesTabState {
    error: string,
    errorDetails?: string,
    isSaving?: boolean
}

class PatientVitalsAndAllergiesTab extends React.Component<PatientVitalsAndAllergiesTabProps, PatientVitalsAndAllergiesTabState> {
    private todaysVitals: TodaysVitalsEditViewCont;
    private charts: VitalsChartContainer;
    private allergiesRef: AllergyEditViewCont;
    private tabRef: any;

    constructor(props: PatientVitalsAndAllergiesTabProps) {
        super(props);
        this.state = {
            error: null,
            isSaving: false
        }
    }

    componentDidMount() {
        document.getElementsByClassName("ongoing-consultation-main-cont")[0].scrollTop = 0;
    }

    // componentWillUnmount() {
    //     this.saveEditedPatientVitalsAndAllergies();
    // }

    // saveEditedPatientVitalsAndAllergies() {
    //     let updatedAllergies: IPatientAllergy[] = this.allergiesRef.getSaveObject();
    //     this.props.saveEditedVitalsAndAllergies(updatedAllergies);
    // }

   // saveAllergies() {
        // let myInstance = this;
        // let updatedAllergies: IPatientAllergy[] = this.allergiesRef.getSaveObject();
        // this.saveEditedPatientVitalsAndAllergies();
        // if (!this.allergiesRef.isFormDirty()) {
        //     this.setState({isSaving: true, error: null})
        //     this.props.savePatientMedicalProfile(this.props.patientId, { allergies: updatedAllergies },this.props.appointmentId, this.props.doctorType).then(function(){
        //         console.log("Successfully Saved Medical Profile");
        //         myInstance.props.nextTab();
        //     }).catch((err: any) => {
        //         this.setState({
        //             error: AppMessages.let updatedAllergies: IPatientAllergy[] = this.allergiesRef.getSaveObject();
        // this.props.saveEditedVitalsAndAllergies(updatedAllergies);let updatedAllergies: IPatientAllergy[] = this.allergiesRef.getSaveObject();
        // this.props.saveEditedVitalsAndAllergies(updatedAllergies);VITALS_AND_ALLERGIES_SAVE_ERROR,
        //             errorDetails: err.message,
        //             isSaving: false
        //         })
        //     });
        // } else {
        //     this.invalidItemError("Allergies");
        // }
   // }

    generateScrollItems = () => {
        return [
            { name: "Today's Vitals", component: "todays-vitals-sub-container" },
            { name: "Charts", component: "charts-sub-container" },
            { name: "Allergies", component: "allergy-sub-container" }
        ]
    }

    clearErrorMessage = () => {
        this.setState({
            error: null,
            errorDetails: null
        })
    }

   // invalidItemError = (section: string) => {
        // let errorDetails = this.allergiesRef.dirtyFormText();
        // this.setState({
        //     error: AppMessages.VITALS_AND_ALLERGIES_VALIDATION_ERROR,
        //     errorDetails: `Error in ${section}: ${errorDetails}`
        // })
    //}

    render() {
        let errorMessage = !_.isNull(this.state.error) ? this.state.error : AppMessages.VITALS_AND_ALLERGIES_SAVE_ERROR;
        let errorDetails = !_.isNull(this.state.errorDetails) ? this.state.errorDetails : "";
        let saveButtonValue = this.state.isSaving ? "Saving..." : "Save";
        let questionnaire = !_.isEmpty(this.props.patientTypeFormData) && !_.isEmpty(this.props.patientTypeFormData.userForm) &&
                            !_.isEmpty(this.props.patientTypeFormData.userForm.questionResponseDetails) ? this.props.patientTypeFormData.userForm.questionResponseDetails : [];
        return (
            <div className="vitals-and-allergies-tab-container" ref={(tabDOM) => {this.tabRef = tabDOM}}>
                {
                    !_.isNull(this.state.error) &&
                        <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage}
                                        reportError={true} rollbarPayload={{message: errorMessage, errorDetails: errorDetails, request: this.allergiesRef.getSaveObject()}}/>
                }
                {/*<ScrollToContainer componentToScroll={"ongoing-consultation-main-cont"} scrollItems={this.generateScrollItems()}/>*/}
                <div className={"sub-container todays-vitals-sub-container"}>
                    <TodaysVitalsEditViewCont userId={this.props.userId} appointmentId={this.props.appointmentId} patientId={this.props.patientId} staticVitalList={this.props.staticVitalList}
                                        patientVitals={this.props.patientVitals} patientAllergies={this.props.patientAllergies}
                                        fetchPatientVitals={this.props.fetchPatientVitals} savePatientVitals={this.props.savePatientVitals}
                                        fetchAllStaticData={this.props.fetchAllStaticData}
                                        showSummary={false} showCallapseButton={false} editedBy={this.props.editedBy} ref={(vitalsDOM) => {this.todaysVitals = vitalsDOM}} 
                                        metricIds={this.props.metricIds} />

                </div>

                <div className={"sub-container charts-sub-container"}>
                    {
                        this.props.patientVitals &&
                        <CollapsibleCardView titleComponent={"Charts"} showCollapseButton={false}>
                            <VitalsChartContainer patientVitals={this.props.patientVitals} ref={(chartsDOM) => {this.charts = chartsDOM}}/>
                        </CollapsibleCardView>
                    }
                </div>
                {/* <div className={"sub-container allergy-sub-container"}>
                    <AllergyEditViewCont appointmentId={this.props.appointmentId} ref={(allergyDOM) => {this.allergiesRef = allergyDOM}}
                                         patientId={this.props.patientId} patientAllergies={this.props.patientAllergies}
                                         displayMode={EditViewDisplayMode.EDIT} editedBy={this.props.editedBy} onInvalidItem={this.invalidItemError}
                                         questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping}/>
                </div> */}

                {/* <div className={"save-button collapsible-card"}>
                    <input disabled={this.state.isSaving} className="card-primary-action" type="button" value={saveButtonValue} onClick={() => {
                        this.saveAllergies();
                    }} /></div> */}
            </div>
        );
    }
}

export default PatientVitalsAndAllergiesTab